export const REST_READ_TRANSLATIONS = 'db/read/translations';
export const REST_WRITE_TRANSLATIONS = 'db/write/translations';